import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ErrorResponse } from '../../models/error.model';
import { TokenResponse } from '../../models/token.model';
import { AppService } from '../../models/app.service.model';
import { Invitation, InvitationsResponse } from '../../models/invitation.model';
import { MessageResponse } from '../../models/message.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthInvitation {
  static apiResponse: ApiResponse

  public static async getMyInvitations(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let invitationsResponse: InvitationsResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/invitations.data.json').then(response => { invitationsResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: invitationsResponse!.success === true ? invitationsResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations/mine`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async getCompanyInvitations(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: []
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data?.invitations ?? response.data?.data ?? []
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async postInvitation(
    api_key: string,
    email: string,
    roles: string[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        email: email,
        role_ids: roles
      }

      await axios.post(url, data, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async postInvitationLink(
    api_key: string,
    token_invitation: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let tokenResponse: TokenResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/token.data.json').then(response => { tokenResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key) && token_invitation.length) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: tokenResponse!.success === true ? tokenResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations/link`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        token: token_invitation
      }

      await axios.post(url, data, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async postInvitationAccept(
    api_key: string,
    token: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key) && token.length) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations/accept`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        token: token
      }

      await axios.post(url, data, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async postInvitationReject(
    api_key: string,
    token: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key) && token.length) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations/reject`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        token: token
      }

      await axios.post(url, data, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async deleteInvitation(
    api_key: string,
    id_invitation: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let invitations: Invitation[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/invitations.data.json').then(response => { invitations = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (invitations!.some(item => item.id === id_invitation)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/invitations/${id_invitation}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.delete(url, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.success === true ? response.data.data : null
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.success === false ? error.response.data.error : { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
